<div fxLayout="column" fxFlexFill class="content-container" fxLayoutGap="5px">
  <app-grid-filter placeholder="Type '/' to bring up a list of available filters"
                   (selectedItemsChanged)="onSelectedItemsChanged($event)"
                   [selectedItemsChange]="selectedFilterChange"
                   (onInitialized)="onGridFilterInitialized($event)"
                   [showFilterButton]="true" (onFilterButtonClicked)="openFilterDialog()"
                   [showDateRange]="true" [defaultDateRange]="dateRangeService.selectedDateRange?.action || 0"
                   [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)">
    <app-filter-row-additional-content>
      <button mat-flat-button color="primary" (click)="openExportDialog()">
        <mat-icon>download</mat-icon>
        Export
      </button>
    </app-filter-row-additional-content>
  </app-grid-filter>

  <div fxFlex class="stretched-container">
    <app-call-logs-v2-grid #callLogsGrid [filterChangeEvent]="filterChangeEvent"></app-call-logs-v2-grid>
  </div>
</div>
